window.Products.Clothing.PremiumSlimfitTShirt = function() {
};
window.Products.Clothing.PremiumSlimfitTShirt.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.PremiumSlimfitTShirt.dpi = 150;
window.Products.Clothing.PremiumSlimfitTShirt.has_3d = true;
window.Products.Clothing.PremiumSlimfitTShirt.id = 103;
window.Products.Clothing.PremiumSlimfitTShirt.slug = 'premium-slimfit-t-shirt';
window.Products.Clothing.PremiumSlimfitTShirt.syncColors = true;
window.Products.Clothing.PremiumSlimfitTShirt.texturesLoaded = 0;
window.Products.Clothing.PremiumSlimfitTShirt.texturesLoading = false;
window.Products.Clothing.PremiumSlimfitTShirt.use_glb = true;

window.Products.Clothing.PremiumSlimfitTShirt.prototype.outsideObject = 0;
window.Products.Clothing.PremiumSlimfitTShirt.prototype.detailsObject = 1;
window.Products.Clothing.PremiumSlimfitTShirt.prototype.position = 0.1;

window.Products.Clothing.PremiumSlimfitTShirt.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather")){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.PremiumSlimfitTShirt.prototype.getColor = function(_name){
	colors = {
		"berry": 0xbb4f73,
		"coral": 0xe7674d,
		"heather_aqua": 0x54abbe,
		"heather_red": 0xe6424a,
		"black": 0x171616,
		"navy": 0x1e2437,
		"white": 0xffffff,
		"soft_cream": 0xdec6a5,
		"true_royal": 0x2d4e95,
		"pink": 0xfdc1c3,
		"deep_heather": 0x7a7a7a,
	};

	return new THREE.Color(colors[_name]);
};